import React from "react";

const ShoppingContext = React.createContext({
  shoppingFilter: undefined,
  setShoppingFilter: () => {},
  resetShoppingFilter: () => {},
});

export default ShoppingContext;
